import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAuth, browserLocalPersistence, indexedDBLocalPersistence, inMemoryPersistence } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBwQ345FJJmGzd6USvl0d7xtunKI4Nxqkg",
  authDomain: "chore-champ-d474f.firebaseapp.com",
  projectId: "chore-champ-d474f",
  storageBucket: "chore-champ-d474f.firebasestorage.app",
  messagingSenderId: "994362844767",
  appId: "1:994362844767:web:49534eec22f716a8f39dea"
};

const app = initializeApp(firebaseConfig);

// ✅ Firestore
export const db = getFirestore(app);

// ✅ Storage
export const storage = getStorage(app);

// On native Capacitor, IndexedDB must come first (WKWebView localStorage deadlock).
// On web, browserLocalPersistence (localStorage) is synchronous — onAuthStateChanged
// fires with the user immediately on page load, preventing the redirect-return flash.
const isNative = window.Capacitor?.isNativePlatform?.();
export const auth = initializeAuth(app, {
  persistence: isNative
    ? [indexedDBLocalPersistence, browserLocalPersistence, inMemoryPersistence]
    : [browserLocalPersistence, indexedDBLocalPersistence, inMemoryPersistence]
});